import React from 'react';
import classnames from 'classnames'
import { Translate } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PropertySkFormButtons extends React.Component {
    static defaultProps = {
        isBusy: false,
        isDisabled: false
    };

    render() {
        return (
            <div className='columns m-0 is-centered has-text-centered'>
                <div className='column is-narrow'>
                    {this.props.backClick &&
                        <button className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={this.props.backClick}>
                            <Translate id="Common.Back" />
                        </button>
                    }
                    <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        type='submit'
                        style={{ fontWeight: 600 }}
                        disabled={this.props.isBusy || this.props.isDisabled}
                    >
                        {this.props.isBusy ? <FontAwesomeIcon icon="cog" spin /> : this.props.searchBtnTxt ? this.props.searchBtnTxt : <Translate id='Search.Common.Search' />}
                    </button>
                </div>
            </div>
        );
    }
}

export default (PropertySkFormButtons);